var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.params.value)?_c('v-icon',{attrs:{"color":"success","small":""}},[_vm._v("far fa-check-circle")]):_vm._e(),(!_vm.params.value)?_c('v-icon',{attrs:{"color":"error","small":""}},[_vm._v("far fa-times-circle")]):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d2c4628","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/CheckComponent.vue
// module id = null
// module chunks = 